import React, { useState } from "react";
import style from "./style.module.scss"
import { ReactComponent as GeminiLogo } from '../../../../assets/svg/ai-agents/geminiIcon.svg'
import { ReactComponent as GptLogo } from '../../../../assets/svg/ai-agents/gptIcon.svg'
import { ReactComponent as ClaudeLogo } from '../../../../assets/svg/ai-agents/claude-ai-icon.svg'
import { ReactComponent as EditIcon } from '../../../../assets/svg/ai-agents/editIcon.svg'
import { ReactComponent as UniphoreLogo } from '../../../../assets/svg/sidemenu/uniphore_logo.svg'
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/ai-agents/deleteIcon.svg'
import { Agent, WorkflowAgent } from "./types";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAgentName } from "../../../../stateManager/store/apps/actions";
import { Button, message, Modal } from "antd";
import { Http } from "../../../../helpers/axois";

type WorkflowAgentsProps = { 
    agent: WorkflowAgent
    appId: string
    deleteAgent: (val: string) => void
    setOpenModal:(val: boolean) => void
    setDeleteAgentData: (val : {id: string, name: string}) => void
    canEditAgents: boolean
    canDeleteAgents: boolean
    setFlowAgentDetails: any
    flowAgentsDetails: WorkflowAgent[]
    cardColor: {
        background: string,
        border: string
    }
}

export const WorkflowAgents = ({ flowAgentsDetails, setFlowAgentDetails, agent, appId, deleteAgent, setOpenModal, setDeleteAgentData, canEditAgents, canDeleteAgents, cardColor }: WorkflowAgentsProps) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const {selectedApp:{type: selectedAppType, chatType}, appBranch, appVersion} = useSelector(
        (state: any) => state.apps
    );

    const [makePrimaryModalVisible, setMakePrimaryModalVisible] = useState<boolean>(false);
    const primaryAgent = flowAgentsDetails.find(item => item.isPrimary);

    const visibleMakePrimary = selectedAppType === "a8chat" && chatType === "genai";
    const makePrimary = async (id: string, name: string) => {
        const branchId = appBranch[appId]?.branchId;
        const versionId = appVersion[appId]?.versionId
        try {
            const url = `apps/${appId}/ai-agents/primary-agent/${id}?branchId=${branchId}&versionId=${versionId}`;
            const res: any = await Http.put(url).toPromise();  
            setMakePrimaryModalVisible(false)
            setFlowAgentDetails((prev: WorkflowAgent[]) => (
                prev.map((item) => {
                    return item.id === id ? {...item, isPrimary: true} : { ...item, isPrimary: false}
                })
            ))
            message.success(`Primary agent updated to ${name}.`);
          } catch(e) {
            message.error("Failed to update primary agent!")
            console.log("Failed to update make primary", e)
          }
    }

    return (
        <>
            <div className={style.agentCard} style={{
                background: cardColor.background,
                border: `1px solid ${cardColor.border}`
            }}>
                <div className={style.agentCardCont}>
                    <h2 className={style.agentName}>{agent.name}</h2>
                    {visibleMakePrimary && (agent.isPrimary ? <span className={style.agentPrimary}>Primary</span> : <span onClick={() => {setMakePrimaryModalVisible(true);}} className={style.agentMakePrimary}>Make Primary</span>)}
                </div>
                <div className={style.agentDesc}>{agent.prompt}</div>
                {/* <p className={style.agentFunction}>{agent.llm.model}</p> */}
                <div className={style.agentFooter}>
                    <div className={style.agentSelectedModels}
                        style={{
                            background: "linear-gradient(91.41deg, #8B3CDA-11.53%, #3C92DA98.8%)"
                        }}
                    >
                        {agent.llm.provider === "openai" ? <GptLogo /> : agent.llm.provider === "gemini" ? <GeminiLogo /> : agent.llm.provider === "anthropic" ? <ClaudeLogo/> : 
                            <UniphoreLogo style={{ height: 18, width: 18 }} />
                        
                        }
                        <span style={{
                            fontSize: 13,
                            fontWeight: 700,
                            paddingLeft: 5,
                            background: agent.llm.provider === "openai" ? "#000000" : agent.llm.provider === "gemini" ? "linear-gradient(91.41deg, #8B3CDA -11.53%, #3C92DA 98.8%)" : agent.llm.provider === "anthropic" ? "#ba5b38" : "#f12066",
                            WebkitBackgroundClip: "text",
                            WebkitTextFillColor: "transparent",
                            backgroundClip: "text",
                            textTransform: "capitalize"
                        }}>
                            {agent.llm.provider}</span>
                        <div className={style.variableCardDivider}></div>
                        <span style={{ paddingLeft: 10, color: "#000000", fontSize: 12, fontWeight: 500}}>{agent.llm.model}</span>
                    </div>
                    {!agent.isExternal && <div className={style.agentActions}>
                        {<button className={style.agentEditButton}
                            onClick={() => {
                                dispatch(updateAgentName(agent.name))
                                const locationPath = (selectedAppType === "a8solo" || selectedAppType === "a8chat") ? "solo" : "assist"
                                history.push(`/apps/list/${appId}/${locationPath}/ai-agents/${agent?.id}/workFlowAgents/edit`)
                            }}
                        >
                            <EditIcon/>
                        </button>}
                        {canDeleteAgents && <button className={style.agentDeleteButton} onClick={() => {setOpenModal(true); setDeleteAgentData({id: agent.id || "", name: agent.name})}}>
                            <DeleteIcon/>
                        </button>}
                    </div>}
                </div>
            </div>
            {
                makePrimaryModalVisible && <Modal
                    className='agent-makePrimary-modal'
                    visible={makePrimaryModalVisible}
                    title="CONFIRM"
                    onCancel={() => {
                        setMakePrimaryModalVisible(false)
                    }}
                    destroyOnClose={true}
                    footer={
                        <>
                            <Button className={style.makePrimaryModalCancelBtn} color="light" size="small" onClick={() => {
                                setMakePrimaryModalVisible(false)
                            }}>
                                Cancel
                            </Button>
                            <Button
                                className={style.makePrimaryModalConfirmBtn}
                                size="small"
                                onClick={() => {
                                    makePrimary(agent.id, agent.name)
                                }}
                            >
                                Proceed
                            </Button>
                        </>
                    }
                >
                    <>
                        <p style={{padding: "10px 20px"}} className={style.agentNameConfirm}>Your current primary AI agent is <span style={{color: "#292D32", fontWeight: 700}} className={style.deleteAgentName}>{primaryAgent?.name}</span>. Are you sure you want to switch the primary AI agent to <span style={{color: "#292D32", fontWeight: 700}} className={style.deleteAgentName}> {agent.name}</span></p>
                    </>
                </Modal>
            }
        </>
    )
}